import { render, staticRenderFns } from "./ruleSet.vue?vue&type=template&id=64e5145f&scoped=true&"
import script from "./ruleSet.vue?vue&type=script&lang=js&"
export * from "./ruleSet.vue?vue&type=script&lang=js&"
import style0 from "./ruleSet.vue?vue&type=style&index=0&id=64e5145f&prod&lang=scss&scoped=true&"
import style1 from "./ruleSet.vue?vue&type=style&index=1&id=64e5145f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5145f",
  null
  
)

export default component.exports